export default "__VITE_ASSET__vRrzDjXW__"